import { Card } from "@/components/ui/card";
import { RecaptchaProvider } from "@/features/company/contact/components/recaptcha-provider";

function Contact() {
    return (
        <div className="flex min-h-full px-4 pt-6 pb-24 md:px-10">
            <div className="container mx-auto md:pt-15">
                <div className="mx-auto prose max-w-4xl prose-darkgreen">
                    <p className="text-center text-sm font-medium tracking-[0.32em] text-neutral-400 uppercase">
                        HELP CENTRE
                    </p>

                    <h1 className="mb-4 text-center text-6xl font-semibold tracking-wider">
                        How can we help?
                    </h1>

                    <p className="lead text-center text-neutral-500">
                        Send us a message and our team will get back to you.
                    </p>

                    <Card
                        size="lg"
                        className="not-prose mx-auto block max-w-2xl"
                    >
                        <RecaptchaProvider />
                    </Card>
                </div>
            </div>
        </div>
    );
}

export default Contact;
